import 'date-fns';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import ruLocale from 'date-fns/locale/ru';
import React, { Fragment, useEffect, useState } from 'react';

import { ContainerContext, coreContainer, extensionContainer } from '../common/container/ContainerContext';
import { loadExtension } from './../extension/loadExtension';
import { ConfigManager } from './config/ConfigManager';
import { RootContainerType, rootContainerFactory } from './containers/rootContainerFactory';

const Application: React.FC = ({ children }) => {
  //@ts-ignore
  // window.isExtensionLoaded = false;
  const [isExtensionsLoaded, setExtensionsLoaded] = useState<boolean>(false);

  const [extensionContainerState] = useState(extensionContainer);
  const [coreContainerState] = useState(coreContainer);
  useEffect(() => {
    const load = async () => {
      //@ts-ignore
      if (isExtensionsLoaded === false && coreContainerState && extensionContainerState && loadExtension) {
        await rootContainerFactory(RootContainerType.default, coreContainerState);
        const extensions = ConfigManager.getConfig()?.extensions?.include || [];

        //@ts-ignore
        await loadExtension(extensions || [], extensionContainerState);
        //@ts-ignore

        setExtensionsLoaded(true);
      }
    };

    load();
    //@ts-ignore
  }, [isExtensionsLoaded, coreContainerState, extensionContainerState]);

  return (
    <Fragment>
      <ContainerContext.Provider value={coreContainerState}>
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={ruLocale}>
          {isExtensionsLoaded && children}
        </LocalizationProvider>
      </ContainerContext.Provider>
    </Fragment>
  );
};

export default Application;
